export default {
    StockVerifyConfigutration: {
        strategy: 'Inventory Review Strategy',
        audit: 'Logical Warehouse Transfer Review',
        virtual: 'Virtual Warehouse Transfer Review',
        approval: 'Inventory Reservation Review',
        review: 'Warehouse Allocation Plan Review',
        confirmMsg: 'The current page data is not saved, whether to reset it directly？',
        cancelled: 'Cancelled'
    }
};

